import { useDeveloperStore } from '@stores';
import { toast } from 'react-toastify';
import Toggle from '@components/toggle/Toggle';

import { Button } from '@trussworks/react-uswds';
import TextAreaInput from '@components/textarea/TextArea';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, FormProvider } from 'react-hook-form';
import { DeveloperAccessService } from '@src/api/services/developer/service';
import { ResponseStatuses } from '@src/utils/enums';

const schema = yup.object().shape({
  banner: yup.string().required('Field is required'),
});

const BannerSettings = () => {
  const { bannerInfo } = useDeveloperStore();
  const { banner, isBannerOn } = bannerInfo;

  const defaultValues = {
    banner: banner ?? null,
    isBannerOn: isBannerOn ?? false,
  };

  const methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
    mode: 'onBlur',
    stateOptions: [],
  });
  const {
    formState: { isValid },
    watch,
    trigger,
    setValue,
  } = methods;

  const bannerValue = watch('banner');
  const isBannerOnValue = watch('isBannerOn');

  const handleSubmit = async () => {
    // Update banner text
    if (isValid) {
      const response = await DeveloperAccessService.updateBannerText(bannerValue);
      if (response.status === ResponseStatuses.Success) {
        DeveloperAccessService.getBannerInfo();
        toast.success('Successfully updated banner text');
      } else {
        toast.error('An error occurred while updating banner text');
      }
    } else {
      trigger();
      toast.error('Please fill out all required fields!');
    }
  };

  const handleBannerStatus = async (val) => {
    const response = await DeveloperAccessService.updateBannerStatus(val);
    if (response.status === ResponseStatuses.Success) {
      toast.success('Successfully updated banner status');
      DeveloperAccessService.getBannerInfo();
    } else {
      toast.error('An error occurred while updating banner status');
    }
    response && setValue('isBannerOn', val);
  };

  const onLabel = <span className={`banner-toggle-label enabled ${isBannerOnValue ? 'selected' : null}`}>Enabled</span>;
  const offLabel = (
    <span className={`banner-toggle-label disabled ${isBannerOnValue ? null : 'selected'}`}>Disabled</span>
  );

  return (
    <FormProvider {...methods}>
      <div>
        <div style={{ width: '740px' }}>
          <TextAreaInput name='banner' label='Banner Message' required />
        </div>
        <Button title='Update Banner' size='small' onClick={() => handleSubmit()} style={{ marginTop: '1rem' }}>
          Update Banner
        </Button>

        <div className='usa-label' style={{ marginTop: '2rem' }}>
          Current Status:
        </div>
        <Toggle onChange={handleBannerStatus} checked={isBannerOn} onLabel={onLabel} offLabel={offLabel} />
      </div>
    </FormProvider>
  );
};

export default BannerSettings;
